import React from 'react';
import _ from 'lodash';

import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from 'reactstrap';

import qs from 'qs';
import { withRouter } from 'react-router-dom';

import { urlify } from '../../utils';
import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';

class ModelTypeFilter extends baseFilter {

    constructor(props) {
        super(props);

        this.renderModelTypeCheckboxes =
            this.renderModelTypeCheckboxes.bind(this);

        this.toggleCheckbox =
            this.toggleCheckbox.bind(this);

        this.updateAPIURL =
            this.updateAPIURL.bind(this);

        this.processResponse =
            this.processResponse.bind(this);

        this.toggleCollapse =
            this.toggleCollapse.bind(this);

        const current_qs = qs.parse(
            window.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        this.state = {
            filters:
                ModelTypeFilter.getActiveFiltersFromQS(
                    current_qs,
                    {
                        "Organoid": {
                            filter_name: "organoid",
                            active: false,
                            count: null
                        },

                        "Cell Line": {
                            filter_name: "cell_line",
                            active: false,
                            count: null
                        }
                    }
                ),

            isOpen: false,
            activeCount: 0
        };

        this.aggregates = {
            'model_type': 'count'
        };
    }

    static getDerivedStateFromProps(
        newprops,
        oldstate
    ) {
        const current_qs = qs.parse(
            newprops.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        const newfilters =
            ModelTypeFilter.getActiveFiltersFromQS(
                current_qs,
                oldstate.filters
            );

        return {
            filters: newfilters,
            activeCount: _.filter(
                newfilters,
                'active'
            ).length
        };
    }

    static getActiveFiltersFromQS(
        qs_obj,
        oldfilters
    ) {
        const qs_typeFilter = (
            'model_type' in qs_obj
                ? _.split(
                    qs_obj.model_type,
                    '_'
                )
                : []
        );

        return _.reduce(
            oldfilters,
            (result, filterProps, type) => {

                result[type] = {
                    ...filterProps,
                    active:
                        qs_typeFilter.indexOf(
                            urlify(type)
                        ) >= 0
                };

                return result;
            },
            {}
        );
    }

    toggleCollapse() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    updateAPIURL(
        api_qs,
        newlistprops
    ) {
        const new_qs = qs.parse(
            newlistprops.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        const activeModelTypeFilters =
            ModelTypeFilter.getActiveFiltersFromQS(
                new_qs,
                this.state.filters
            );

        const apiModelTypeFilters = _.map(
            _.filter(
                _.toPairs(
                    activeModelTypeFilters
                ),
                ([type, filterProps]) =>
                    filterProps.active
            ),
            ([type, filterProps]) =>
                filterProps.filter_name
        );

        if (
            apiModelTypeFilters.length > 0
        ) {
            const filter_qs = {
                name: 'model_type',
                op: 'in',
                val: apiModelTypeFilters
            };

            api_qs.filter = _.get(
                api_qs,
                'filter',
                []
            ).concat(filter_qs);
        }

        return _.merge(api_qs, {
            agg: this.aggregates
        });
    }

    processResponse(response) {
        const resp_agg =
            this.get_agg_values(response);

        const agg_field =
            _.keys(this.aggregates)[0];

        if (!resp_agg) {
            return;
        }

        const counts = _.get(
            resp_agg,
            `${agg_field}.${this.aggregates[agg_field]}`,
            {}
        );

        /*
         * Preserve Organoid and Cell Line even when
         * the API doesn't return a count for one of them.
         */
        const newfilters = _.mapValues(
            this.state.filters,
            filterProps => ({
                ...filterProps,
                count: _.get(
                    counts,
                    filterProps.filter_name,
                    0
                )
            })
        );

        /*
         * Some APIs return the display value rather
         * than the filter_name, so fall back to that.
         */
        _.forEach(
            newfilters,
            (filterProps, modelType) => {

                if (
                    filterProps.count === 0
                ) {
                    const directCount =
                        _.get(
                            counts,
                            modelType,
                            undefined
                        );

                    if (
                        directCount !== undefined
                    ) {
                        newfilters[
                            modelType
                        ] = {
                            ...filterProps,
                            count: directCount
                        };
                    }
                }
            }
        );

        this.setState({
            filters: newfilters
        });
    }

    toggleCheckbox(event) {
        const model_type =
            urlify(event.target.name);

        const current_qs = qs.parse(
            window.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        let typeFilter = (
            'model_type' in current_qs
                ? _.split(
                    current_qs.model_type,
                    '_'
                )
                : []
        );

        if (event.target.checked) {

            if (
                typeFilter.indexOf(
                    model_type
                ) === -1
            ) {
                typeFilter.push(
                    model_type
                );
            }

        } else {

            typeFilter =
                typeFilter.filter(
                    item =>
                        urlify(item) !==
                        model_type
                );
        }

        current_qs.model_type =
            typeFilter.length > 0
                ? _.join(
                    typeFilter.sort(),
                    '_'
                )
                : undefined;

        current_qs.page = undefined;

        this.props.history.push(
            window.location.pathname +
            qs.stringify(
                current_qs,
                {
                    addQueryPrefix: true
                }
            )
        );
    }

    renderModelTypeCheckboxes() {
        return _.map(
            _.toPairs(this.state.filters),
            ([model_type, details]) => (
                <FormGroup
                    check
                    key={model_type}
                >
                    <Input
                        type="checkbox"
                        name={model_type}
                        onChange={this.toggleCheckbox}
                        checked={_.get(
                            details,
                            'active',
                            false
                        )}
                    />{' '}

                    <Label
                        className="ml-4 mt-1"
                        check
                    >
                        {model_type}

                        {details.count !== null &&
                            details.count !== undefined && (
                                <span className="secondary">
                                    {' '}(
                                    {details.count}
                                    )
                                </span>
                            )}
                    </Label>
                </FormGroup>
            )
        );
    }

    componentDidMount() {
        this.props.registerResponse(
            this.processResponse
        );

        this.props.registerRequest(
            this.updateAPIURL
        );
    }

    componentWillUnmount() {
        this.props.unregisterResponse(
            this.processResponse
        );

        this.props.unregisterRequest(
            this.updateAPIURL
        );
    }

    render() {
        return (
            <Card className="genetic-filters mb-2 z0 hover">

                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >
                    <div className="d-inline w-50">
                        Model Types
                    </div>

                    <div className="d-inline-block">
                        {this.state.activeCount > 0 && (
                            <strong>
                                {
                                    this.state.activeCount +
                                    ' active'
                                }
                            </strong>
                        )}
                    </div>

                    <CollapseButton
                        isOpen={this.state.isOpen}
                        onClick={this.toggleCollapse}
                    />
                </CardHeader>

                <Collapse isOpen={this.state.isOpen}>
                    <CardBody>
                        {this.renderModelTypeCheckboxes()}
                    </CardBody>
                </Collapse>

            </Card>
        );
    }
}

export default withRouter(
    ModelTypeFilter
);